import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.delay = 5000
    this.resume()
  }

  disconnect() {
    this.pause()
  }

  pause() {
    clearTimeout(this.timeout)
    this.remaining -= Date.now() - this.startTime
  }

  resume() {
    this.startTime = Date.now()
    clearTimeout(this.timeout)
    this.remaining = this.remaining || this.delay
    this.timeout = setTimeout(() => this.dismiss(), this.remaining)
  }

  dismiss() {
    this.element.classList.add("opacity-0", "transition-opacity", "duration-500", "ease-out")
    this.element.addEventListener("transitionend", () => {
      this.element.remove()
    })
  }

  close() {
    this.pause()
    this.dismiss()
  }
}
